import { getFromStorage } from '../utils/Helper';

const EN = {
  title: 'Delete Item',
  message: 'Are you sure you want to remove this item?',
  confirm: 'Delete',
};

const ES = {
  title: 'Eliminar Item',
  message: '¿Está seguro de que desea eliminar este Item?',
  confirm: 'Eliminar',
};

export function getProductDeleteModalCopy() {
  const lang =
    getFromStorage({ key: 'Translate' }) ??
    (typeof window !== 'undefined' ? window.localStorage?.getItem('Translate') : null);
  return lang === 'spa' ? ES : EN;
}
